import styled from "styled-components";
import { motion } from "framer-motion";

export const FabWrap = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 900;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const Fab = styled(motion.button)`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) =>
    theme.light ? "rgba(255, 255, 255, 0.9)" : theme.buttonBg};
  border: 1px solid ${({ theme }) => theme.accent};
  color: ${({ theme }) => theme.accent};
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: rgba(${({ theme }) => theme.accentRgb}, 0.1);
  }
`;
